import React from "react";

const OptionsIcon = ({color  = "#464646",rotate = 0}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: `rotate(${rotate}deg)` }} >
      <g clip-path="url(#clip0_1310_5982)">
        <path
          d="M3 12C3 7.03738 7.03738 3 12 3C16.9626 3 21 7.03738 21 12C21 16.9626 16.9626 21 12 21C7.03738 21 3 16.9626 3 12ZM20.2266 12C20.2266 7.46386 16.5361 3.77344 12 3.77344C7.46386 3.77344 3.77344 7.46386 3.77344 12C3.77344 16.5361 7.46386 20.2266 12 20.2266C16.5361 20.2266 20.2266 16.5361 20.2266 12Z"
          fill={color}
        />
        <path
          d="M10.7344 7.95703C10.7344 7.25914 11.3021 6.69141 12 6.69141C12.6979 6.69141 13.2656 7.25914 13.2656 7.95703C13.2656 8.65492 12.6979 9.22266 12 9.22266C11.3021 9.22266 10.7344 8.65492 10.7344 7.95703ZM12.4922 7.95703C12.4922 7.68562 12.2714 7.46484 12 7.46484C11.7286 7.46484 11.5078 7.68562 11.5078 7.95703C11.5078 8.22844 11.7286 8.44922 12 8.44922C12.2714 8.44922 12.4922 8.22844 12.4922 7.95703Z"
          fill={color}
        />
        <path
          d="M10.7344 12C10.7344 11.3021 11.3021 10.7344 12 10.7344C12.6979 10.7344 13.2656 11.3021 13.2656 12C13.2656 12.6979 12.6979 13.2656 12 13.2656C11.3021 13.2656 10.7344 12.6979 10.7344 12ZM12.4922 12C12.4922 11.7286 12.2714 11.5078 12 11.5078C11.7286 11.5078 11.5078 11.7286 11.5078 12C11.5078 12.2714 11.7286 12.4922 12 12.4922C12.2714 12.4922 12.4922 12.2714 12.4922 12Z"
          fill={color}
        />
        <path
          d="M10.7344 16.043C10.7344 15.3451 11.3021 14.7773 12 14.7773C12.6979 14.7773 13.2656 15.3451 13.2656 16.043C13.2656 16.7409 12.6979 17.3086 12 17.3086C11.3021 17.3086 10.7344 16.7409 10.7344 16.043ZM12.4922 16.043C12.4922 15.7716 12.2714 15.5508 12 15.5508C11.7286 15.5508 11.5078 15.7716 11.5078 16.043C11.5078 16.3144 11.7286 16.5352 12 16.5352C12.2714 16.5352 12.4922 16.3144 12.4922 16.043Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1310_5982">
          <rect width="18" height="18" fill="white" transform="translate(21 3) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OptionsIcon;
